var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudyTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3729)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6328 26.9179C38.0865 26.9179 37.5804 27.0704 37.1335 27.3203L33.8703 21.8292L34.6665 21.1071L31.3227 17.416L29.1903 21.2384L31.5938 23.8939L32.3519 23.2057L35.755 28.8386C35.5208 29.385 35.4449 29.9862 35.5359 30.5737C35.6268 31.1611 35.8811 31.7112 36.2695 32.1612L33.667 40.4814C32.2109 39.9791 30.6818 39.7208 29.1415 39.717C23.3815 39.717 18.4728 38.9228 16.4907 43.7744H41.7881C40.6361 40.9579 38.4804 42.8786 35.7677 41.4111L38.2877 33.2391C38.3999 33.2518 38.5079 33.2751 38.6265 33.2751C39.0712 33.2751 39.4926 33.1777 39.8759 33.0083C40.5175 32.7245 41.0364 32.2247 41.3667 31.6064C41.6103 31.1574 41.7606 30.6492 41.7606 30.1007C41.7648 29.6862 41.6872 29.2749 41.5321 28.8905C41.3771 28.506 41.1477 28.1559 40.8572 27.8603C40.5666 27.5646 40.2206 27.3292 39.8389 27.1675C39.4572 27.0057 39.0474 26.9209 38.6328 26.9179Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4582 14.1621L27.6739 9.97974L16.5923 14.7974L25.5732 24.7164L31.4582 14.1621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4723 21.2722C21.5878 23.6101 23.4577 22.2675 23.4577 22.2675L18.8455 17.1703C18.8455 17.1703 17.3504 18.9343 19.4723 21.2722Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyTable);
export default __webpack_public_path__ + "static/media/studyTable.52f677e0b113ddc41ccb70e0601f33c6.svg";
export { ForwardRef as ReactComponent };